import { useIntl } from "react-intl";

export default function LibraryOrigin({ name, version }) {
  const intl = useIntl();
  return (
    <>
      {name || intl.formatMessage({ id: "section.library.sourceTemplateUnknown" })}
      {version != null && ` (${version})`}
    </>
  );
}
